import type { StudioThemeId } from 'fym-shared/src/music24/studioThemes';

export type ProResViewKind = 'locked' | 'make' | 'working' | 'ready' | 'failed';

/**
 * What the ProRes row of the viewer shows (design w): `locked` below Pro, else the state of the
 * file on the server (`none` → `make`). Pure.
 */
export function proResView(input: {
  unlocked: boolean;
  status: 'none' | 'working' | 'failed' | 'ready';
  requesting: boolean;
}): { kind: ProResViewKind } {
  if (!input.unlocked) {
    return { kind: 'locked' };
  }
  if (input.requesting || input.status === 'working') {
    return { kind: 'working' };
  }
  if (input.status === 'ready') {
    return { kind: 'ready' };
  }
  return { kind: input.status === 'failed' ? 'failed' : 'make' };
}

/** Only a kit motion artwork file (square or tall) has a ProRes download. Pure. */
export function hasProResDownload(item: { kind: string; themeId: StudioThemeId }): boolean {
  return item.kind === 'kitAsset' && item.themeId === 'motionArtwork';
}
